import React from 'react';
import './Areas.css';

const areas = [
  { num: '01', title: 'Derecho Laboral', desc: 'Despidos injustificados, indebidos o improcedentes, tutela laboral (vulneración de derechos fundamentales), despido indirecto (autodespido), nulidad del despido, cobro o mal cálculo de finiquitos, reclamos ante la Inspección del Trabajo, denuncias y negociación colectiva, entre otros.', cta: 'Te ayudamos a hacer valer tus derechos.', href: '/areas/derecho-laboral' },
  { num: '02', title: 'Derecho de Familia', desc: 'Divorcios, pensiones alimenticias, relación directa y regular (visitas), cuidado personal (tuición), reclamación e impugnación de filiación, adopción, capitulaciones matrimoniales, violencia intrafamiliar, causas proteccionales, mediación familiar, entre otros.', cta: 'Te explicamos y acompañamos en cada paso del proceso.', href: '/areas/derecho-familia' },
  { num: '03', title: 'Derecho Migratorio', desc: 'Residencia temporales y definitivas, permisos de trabajo, reunificación familiar, recursos de amparo ante demoras u obstáculos en la obtención visas o ante procesos de deportación, devolución de fondos previsionales (AFP), entre otros.', cta: 'Te protegemos, acompañamos y agilizamos tu caso.', href: undefined },
  { num: '04', title: 'Derecho Civil', desc: 'Contratos, arriendos, compraventas, donaciones, cobro de deudas, herencias, responsabilidad contractual y extracontractual, entre otros.', cta: 'Te orientamos con claridad y buscamos soluciones efectivas para tu caso.', href: '/areas/derecho-civil' },
];

const icons: Record<string, React.ReactNode> = {
  '01': (
    <svg className="area-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  '02': (
    <svg className="area-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  '03': (
    <svg className="area-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
      <circle cx={12} cy={12} r={10} />
      <line x1={2} y1={12} x2={22} y2={12} />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  '04': (
    <svg className="area-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
};

const Areas: React.FC = () => (
  <section id="areas">
    <div className="section-label">Especialidades</div>
    <h2 className="section-title">Nuestras <em>áreas</em><br />de práctica</h2>
    <p className="areas-subtitle">
      Somos un estudio de abogadas en Concepción con experiencia en múltiples ramas del derecho. Si buscas abogados en Concepción para tu caso, te brindamos asesoría integral y representación de calidad.
    </p>
    <div className="areas-grid">
      {areas.map((a) => {
        const inner = (
          <>
            <div className="area-num">{a.num}</div>
            {icons[a.num]}
            <div className="area-title">{a.title}</div>
            <div className="area-desc">{a.desc}</div>
            <div className="area-cta">{a.cta}</div>
            {a.href && <div className="area-more">Preguntas frecuentes →</div>}
          </>
        );
        return a.href ? (
          <a
            key={a.num}
            className="area-card area-card--link"
            href={a.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {inner}
          </a>
        ) : (
          <div className="area-card" key={a.num}>{inner}</div>
        );
      })}
    </div>
  </section>
);

export default Areas;
